module.exports = {"client_id":"access_control_ui","redirect_relative_uri":"/#/callback?","silent_redirect_relative_uri":"/#/silentrenewcallback?","response_type":"id_token token","scope":"openid profile email access_control_api access-control-permissions tenant_name","post_logout_redirect_relative_uri":"/#/","automaticSilentRenew":false}


//////////////////
// WEBPACK FOOTER
// ./src/services/oidc/oidc.config.json
// module id = 1136
// module chunks = 0